import * as Types from "@/lib/Util/Types/Types"

export const VALUES = {
    PerTrx: true,
    Weekly: true,
    BiWeekly: true,
    Monthly: true,
} as const

export type Record = typeof VALUES

export type T = Types.RecToDUWithValueOfKindName<Record>
export type Kind = T['kind']

export const KEYS: Kind[] = Types.getKindNames<Record, Kind>(VALUES)

export function getEmpty(): T {
    return { kind: 'PerTrx', PerTrx: true }
}

export function getByKind(x: Kind): T {
    return Types.makeSingleDUFromString(x)
}

export const tryParse = Types.buildTryParse<T, true>(VALUES, "kind", true, "InvoicingTerms")